export default __webpack_public_path__ + "static/Doki-04fea1fae48f470b3ce7e4cdcd99b1c0.png";